<div class="layout new-offer">
  <app-header-data
    [headerCol]="headerCol"
    (clickButton)="handleButton($event)"
    class="new-offer__header"
  ></app-header-data>
  <main>
    <div class="layout new-offer__loading-new-offer" *ngIf="isLoading">
      <app-loading [onlyIcon]="true"></app-loading>
      {{ 'COMMONS.LOADING' | i18nextEager }}
    </div>
    <div class="new-offer__required">
      <span>* {{ 'COMMONS.REQUIRED' | i18nextEager }} </span>
    </div>
    <form [formGroup]="newOfferForm">
      <section>
        <h2>{{ 'NEW_OFFER.BASIC_DATA' | i18nextEager }}</h2>
        <div class="new-offer__form">
          <app-custom-select
            [label]="'NEW_OFFER.ACCOUNT'"
            [controlName]="'codCuentaNegociadora'"
            [values]="accountList"
            [disabled]="accountDisabled"
            [searchBar]="true"
          ></app-custom-select>
          <app-custom-select
            [label]="'NEW_OFFER.BUSINESS'"
            [controlName]="'codesRazonSocial'"
            [values]="businessList"
            [defaultValue]="this.newOfferForm.get('codesRazonSocial').value"
            [disabled]="businessDisabled"
            [multiple]="true"
            [selectAllOption]="true"
          ></app-custom-select>
          <app-custom-select
            [label]="'NEW_OFFER.INSTALLATION'"
            [controlName]="'codesInstalacion'"
            [values]="installationList"
            [defaultValue]="newOfferForm.get('codesInstalacion').value"
            [disabled]="installationDisabled"
            [multiple]="true"
            [selectAllOption]="true"
          ></app-custom-select>
        </div>
      </section>
      <section>
        <h2>{{ 'NEW_OFFER.OFFER_DATA' | i18nextEager }}</h2>
        <div class="new-offer__form">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_OFFER.OFFER' | i18nextEager }}</mat-label>
            <input matInput formControlName="nombreOferta" maxlength="50" />
            <mat-error
              *ngIf="
                newOfferForm?.controls.nombreOferta.errors?.required &&
                (newOfferForm?.controls.nombreOferta.touched || newOfferForm?.controls.nombreOferta.dirty)
              "
            >
              {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
            </mat-error>
          </mat-form-field>
          <div class="new-offer__toggle">
            <label>{{ 'NEW_OFFER.RENEWAL' | i18nextEager }}</label>
            <mat-radio-group aria-labelledby="" formControlName="renovacionTacita" ngDefaultControl required>
              <mat-radio-button [value]="true">
                <span>{{ 'COMMONS.YES' | i18nextEager }}</span>
              </mat-radio-button>
              <mat-radio-button [value]="false">
                <span>{{ 'COMMONS.NO' | i18nextEager }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="new-offer__toggle">
            <label>{{ 'NEW_OFFER.DUTY' | i18nextEager }}</label>
            <mat-radio-group aria-labelledby="" formControlName="impuestoElectrico" ngDefaultControl required>
              <mat-radio-button [value]="true">
                <span>{{ 'COMMONS.YES' | i18nextEager }}</span>
              </mat-radio-button>
              <mat-radio-button [value]="false">
                <span>{{ 'COMMONS.NO' | i18nextEager }}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <app-custom-select
            [label]="'NEW_OFFER.CAMPAIGN'"
            [controlName]="'codigoCampania'"
            [values]="campaignsList"
            [defaultValue]="newOfferForm.get('codigoCampania').value"
            [disabled]="campaignDisabled"
          ></app-custom-select>
          <app-custom-select
            [label]="'NEW_OFFER.LEVEL'"
            [controlName]="'nombreNivel'"
            [values]="levelList"
            [defaultValue]="newOfferForm.get('nombreNivel').value"
            [disabled]="levelDisabled"
          ></app-custom-select>
          <app-custom-select
            [label]="'NEW_OFFER.TYPE_CONTRACT'"
            [controlName]="'tipoContrato'"
            [values]="typeContract"
            [defaultValue]="newOfferForm.get('tipoContrato').value"
            [disabled]="levelDisabled"
          ></app-custom-select>
        </div>
      </section>
    </form>
  </main>
</div>
